import React from 'react';
import {
  AudioIcon,
  ExcelIcon,
  FileIcon,
  ImageFileIcon,
  PdfIcon,
  PowerPointIcon,
  VideoIcon,
  WordIcon,
  ZipIcon,
} from '../Icons';

/**
 * Returns a colored file-type icon for the given MIME type.
 *
 * @param type the file MIME type
 * @param size optional rendered size in pixels (defaults to the icon's 20px)
 */
export const getFileIcon = (type: string | undefined, size?: number) => {
  switch (type) {
    case 'application/msword':
    case 'aplication/vnd.openxmlformats-officedocument.wordprocessingml.document':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return <WordIcon size={size} />;

    case 'application/vnd.ms-excel':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.template':
    case 'application/vnd.ms-excel.sheet.macroEnabled.12':
    case 'application/vnd.ms-excel.template.macroEnabled.12':
    case 'application/vnd.ms-excel.addin.macroEnabled.12':
    case 'application/vnd.ms-excel.sheet.binary.macroEnabled.12':
      return <ExcelIcon size={size} />;

    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    case 'application/vnd.ms-powerpoint':
      return <PowerPointIcon size={size} />;

    case 'application/pdf':
      return <PdfIcon size={size} />;

    case 'application/gzip':
    case 'application/zip':
      return <ZipIcon size={size} />;
  }

  if (type !== undefined) {
    if (type.startsWith('audio/')) {
      return <AudioIcon size={size} />;
    }

    if (type.startsWith('video/')) {
      return <VideoIcon size={size} />;
    }

    if (type.startsWith('image/')) {
      return <ImageFileIcon size={size} />;
    }
  }

  return <FileIcon size={size} />;
};
